import { render, staticRenderFns } from "./PublicationList.vue?vue&type=template&id=3a3cd211"
import script from "./PublicationList.vue?vue&type=script&lang=js"
export * from "./PublicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports